import { AxiosError } from 'axios';
import { pick, omit } from 'lodash-es';
// eslint-disable-next-line import-x/no-named-default -- default named import conflicts with Webpack
import { default as Pino } from 'pino';
import * as std from 'pino-std-serializers';

const customErrorSerializer = (err: Error) => {
    if (err.constructor === AxiosError) {
        const ax = err as AxiosError;

        return {
            ...omit(ax, 'config', 'request'),
            config: pick(ax.config, 'baseURL', 'url'),
        };
    }

    return std.err(err);
};

const getLogLevel = (): string => {
    // Can't use env.ts here because it's an isomorphic script
    // TODO: this defeats the purpose of Zod validation in @utils/env.ts. Can we make it better?
    if (typeof process === 'undefined') return 'info';
    // eslint-disable-next-line @typescript-eslint/dot-notation -- conflicts with TS4111
    return process.env['HEAD_SITE_MAIN_SERVER_LOG_LEVEL'] || 'info';
};

const options: Pino.LoggerOptions = {
    level: getLogLevel(),
    serializers: {
        req: std.req,
        res: std.res,
        e: customErrorSerializer,
        err: customErrorSerializer,
        error: customErrorSerializer,
    },
    browser: {
        asObject: false,
    },
};

export const Logger = Pino(options);
